"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresProductSelector = void 0;
var _reselect = require("reselect");
var _productsSelectors = require("../../selectors/productsSelectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var futuresProductSelector = exports.futuresProductSelector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.productManifest.manifest;
}, function (state) {
  return state.futures.balances.balances;
}, function (state) {
  return state.futures.products.data;
}, _productsSelectors.baseNotionalProductSymbolSelector, function (products, manifest, futuresBalances, futuresProducts, NotionalSymbol) {
  var _products$find;
  var NotionalDecimalPlaces = ((_products$find = products.find(function (p) {
    return p.Product === NotionalSymbol;
  })) === null || _products$find === void 0 ? void 0 : _products$find.DecimalPlaces) || 2;
  return futuresBalances.map(function (futuresBalanceInfo) {
    var product = products.find(function (b) {
      return (b === null || b === void 0 ? void 0 : b.ProductId) === (futuresBalanceInfo === null || futuresBalanceInfo === void 0 ? void 0 : futuresBalanceInfo.ProductId);
    }) || {};
    var ProductSymbol = product.Product;
    var isApexProductEnabled = !product.IsDisabled;
    var matchingFuturesProduct = futuresProducts.find(function (futuresProduct) {
      return (futuresProduct === null || futuresProduct === void 0 ? void 0 : futuresProduct.ProductId) === product.ProductId;
    });
    var isFuturesProductEnabled = matchingFuturesProduct ? !matchingFuturesProduct.IsDisabled : false;
    var iconFileName = manifest[ProductSymbol] ? manifest[ProductSymbol].iconFileName : "".concat(ProductSymbol, "DEFAULT_ICON");
    return _objectSpread(_objectSpread({}, futuresBalanceInfo), {}, {
      iconFileName: iconFileName,
      ProductId: product.ProductId,
      ProductFullName: product.ProductFullName,
      ProductSymbol: ProductSymbol,
      NotionalSymbol: NotionalSymbol,
      DecimalPlaces: product.DecimalPlaces,
      NotionalDecimalPlaces: NotionalDecimalPlaces,
      isApexProductEnabled: isApexProductEnabled,
      isFuturesProductEnabled: isFuturesProductEnabled
    });
  });
});